// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2cbBq","content":"GlobalSearch_content__3d-Ja"};